const CALENDAR_DAY = /^(\d{4})-(\d{2})-(\d{2})$/

/**
 * A Date to display. A bare "YYYY-MM-DD" (a DOB, a hire date, an expiry) is a calendar
 * day, not an instant: `new Date()` reads it as UTC midnight, which every time zone west
 * of UTC shows as the day before. It is read here as local midnight of that day. Anything
 * else (a timestamp, a Date, a number, null) goes to `new Date()` exactly as before.
 *
 * Not for formatters pinned to `timeZone: 'UTC'`: those already show the right day from
 * `new Date()`, and local midnight would show the day before east of UTC.
 */
export function toDisplayDate(value: string | number | Date | null | undefined): Date {
  if (typeof value === 'string') {
    const day = CALENDAR_DAY.exec(value)
    if (day) return new Date(Number(day[1]), Number(day[2]) - 1, Number(day[3]))
  }
  return new Date(value as string | number | Date)
}
